import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { Button, Spinner } from '@walmart-web/livingdesign-components'
import texts from '../../../common/texts.json'

const SecondSiteToStoreComponent = ({
  isWalstore,
  selectedWalstoreStore,
  showStoreSelectorModal,
  pickupStore,
  pickUpStoresSpinner,
}) => {
  if (isWalstore) return <>{selectedWalstoreStore.value}</>

  return (
    <Button
      onClick={showStoreSelectorModal}
      variant="tertiary"
      size="small"
      className="product-detail-page__button-store-selector"
      trailing={pickUpStoresSpinner && <Spinner size="small" UNSAFE_className="product-detail-page__spinner" />}
    >
      {pickupStore.id ? pickupStore.name : texts.PRODUCT_DETAIL.CHOOSE_STORE_SELECTOR_HEAD}
    </Button>
  )
}

SecondSiteToStoreComponent.defaultProps = {
  isWalstore: false,
  pickUpStoresSpinner: false,
}

SecondSiteToStoreComponent.propTypes = {
  isWalstore: PropTypes.bool,
  selectedWalstoreStore: PropTypes.object.isRequired,
  showStoreSelectorModal: PropTypes.func.isRequired,
  pickupStore: PropTypes.object.isRequired,
  pickUpStoresSpinner: PropTypes.bool,
}

export default SecondSiteToStoreComponent
